import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Home, Calendar, User, Star, HelpCircle, LayoutDashboard, Settings } from 'lucide-react';
import { motion } from 'framer-motion';

interface MobileNavProps {
  isAdmin?: boolean;
}

export default function MobileNav({ isAdmin = false }: MobileNavProps) {
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = isAdmin ? [
    { path: '/admin', icon: LayoutDashboard, label: 'Dashboard' },
    { path: '/admin/bookings', icon: Calendar, label: 'Bookings' },
    { path: '/admin/users', icon: User, label: 'Users' },
    { path: '/admin/settings', icon: Settings, label: 'Settings' }
  ] : [
    { path: '/dashboard', icon: Home, label: 'Home' },
    { path: '/book', icon: Calendar, label: 'Book' },
    { path: '/reviews', icon: Star, label: 'Reviews' },
    { path: '/profile', icon: User, label: 'Profile' }
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <motion.nav
      initial={{ y: 100 }}
      animate={{ y: 0 }}
      className="app-tab-bar"
    >
      {navItems.map((item) => (
        <motion.button
          key={item.path}
          onClick={() => navigate(item.path)}
          className={`app-tab-item ${isActive(item.path) ? 'active' : ''}`}
          whileTap={{ scale: 0.95 }}
        >
          <item.icon className="w-6 h-6" />
          <span className="text-xs font-medium">{item.label}</span>
        </motion.button>
      ))}
    </motion.nav>
  );
}